import React from 'react';
import { painPoints } from '../data/megapack';
import { SectionHeading } from './SectionHeading';
import { useReveal } from '../hooks/useReveal';
export function PainSection() {
  const listRef = useReveal<HTMLUListElement>();
  return <section className="w-full bg-cream px-5 py-16 sm:py-20" aria-labelledby="pain-title" data-id="element-120" data-mp="2uxm47i3g87jz">
      <div className="mx-auto max-w-3xl" data-id="element-121" data-mp="2yyfq65xbzca8">
        <SectionHeading id="pain-title" title={<>
              ¿Te suena <span className="mark-gold" data-id="element-123" data-mp="2l6rjwj9rji16">conocido</span> esto?
            </>} data-id="element-122" data-mp="2l8cci3cioqwe" />

        <div className="mt-8 rounded-3xl border-2 border-forest-100 bg-white p-6 text-center shadow-card sm:p-8" data-id="element-124" data-mp="2q043gezl4yn2">
          <p className="font-display text-xl font-bold text-forest-800 sm:text-2xl" data-id="element-125" data-mp="2bbr73gwl5ds1">
            Domingo a la noche. Mañana tenés sala.
          </p>
          <p className="mt-3 text-sm leading-relaxed text-forest-900/80 sm:text-base" data-id="element-126" data-mp="229qbeoh02zsh">
            Y todavía estás pensando qué actividad hacer, cómo organizar la semana, qué propuesta usar
            para la efeméride que se viene, qué juego preparar para la ronda o cómo resolver esos
            momentos donde el grupo está inquieto y no logra engancharse.
          </p>
          <p className="mt-5 font-hand text-2xl text-blush-600" data-id="element-127" data-mp="3nnicmz3fx193">No es tu culpa.</p>
          <p className="mt-2 text-sm leading-relaxed text-forest-900/80 sm:text-base" data-id="element-128" data-mp="5f18og40qy5z">
            Es que ser maestra jardinera{' '}
            <span className="mark-lime font-bold" data-id="element-129" data-mp="38wj6rvtzoqt7">no termina cuando salís del jardín</span>. Tenés que
            planificar, enseñar, contener, observar, adaptar, comunicar con familias, preparar
            materiales y sostener una sala con niños que cada día llegan con una energía distinta.
          </p>
          <p className="mt-4 text-sm font-extrabold text-forest-800 sm:text-base" data-id="element-130" data-mp="3dvvyouzpwo2n">
            Y cuando no tenés recursos ordenados, todo se vuelve más pesado.
          </p>
        </div>

        <h3 className="mt-14 text-center font-display text-2xl font-extrabold tracking-tight text-forest-800 sm:text-3xl" data-id="element-131" data-mp="2l6yj4zmw55dl">
          El costo de <span className="underline-hand" data-id="element-132" data-mp="p2r53o9hr8tg">no tener el material correcto</span>
        </h3>

        <ul ref={listRef} className="reveal-group mt-9 space-y-3" data-id="element-133" data-mp="u23ou052fzrt">
          {painPoints.map((point, index) => <li key={point.title} className="reveal flex items-start gap-3 rounded-2xl border-2 border-red-200 bg-red-50 p-4" style={{
          transitionDelay: `${index * 50}ms`
        }} data-id="element-134" data-mp="yuogav0i20s6" data-mpi={index}>
              <span className="mt-1.5 h-2.5 w-2.5 flex-none rounded-full bg-red-500 ring-4 ring-red-100" aria-hidden="true" data-id="element-135" data-mp="65py5xwdmymv" />
              <div data-id="element-136" data-mp="b4kp5n4hzti2">
                <h4 className="font-display text-base font-bold text-forest-800" data-id="element-137" data-mp="b658egld3q0m">{point.title}</h4>
                <p className="mt-1 text-[13px] leading-relaxed text-forest-900/70" data-id="element-138" data-mp="f7qsalwbd4kb">{point.text}</p>
              </div>
            </li>)}
        </ul>

        <div className="mt-14 text-center" data-id="element-139" data-mp="1qlkt5vmk85fg">
          <h3 className="font-display text-2xl font-extrabold tracking-tight text-forest-800 sm:text-3xl" data-id="element-140" data-mp="1qkjjnvl6zqzu">
            Basta de <span className="mark-pink" data-id="element-141" data-mp="1vlpdxxui3mbh">regalar tu tiempo libre</span>
          </h3>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-forest-900/80 sm:text-base" data-id="element-142" data-mp="25pxd0o8qldyt">
            Tu vocación ya la tenés. Tus ganas ya las tenés. Tu compromiso con los chicos también. Ahora
            necesitás una herramienta que te ayude a organizar todo eso con más claridad.
          </p>
          <p className="mt-4 font-hand text-3xl text-forest-800" data-id="element-143" data-mp="1rulhwfqo5lhd">
            Planificá tu año con más calma desde hoy.
          </p>
        </div>
      </div>
    </section>;
}